import {
  LabSelectionWidget,
  UnitSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  lab_ids: {
    "ui:widget": LabSelectionWidget,
  },
  unit_ids: {
    "ui:widget": UnitSelectionWidget,
  }
});

export default uiSchema;
